import {AxiosError} from 'axios';
import {POST_SEND_UNIQUE_LINK_EMAIL_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

export interface SendUniqueLinkEmailFormData {
  isOfflinePayment: boolean | null | undefined;
}

export interface SendUniqueLinkEmailRequest extends SendUniqueLinkEmailFormData {
  userType: string;
  uuid: string;
  applicationType: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminAppealSendEmail = ({onSuccess, onError}: Input = {}) => {
  const postAdminAppealSendEmail = async (requestBody: SendUniqueLinkEmailRequest) => {
    const res = await axiosClient.post<void>(POST_SEND_UNIQUE_LINK_EMAIL_URL, requestBody);

    return res.data;
  };

  return useCustomMutation(postAdminAppealSendEmail, {
    onSuccess,
    onError,
  });
};
